import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import Swiper from 'swiper'

import {
  Navigation as SwiperNavigation,
  Pagination,
  Thumbs,
  FreeMode,
  Autoplay,
} from 'swiper/modules'


import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/thumbs'
import 'swiper/css/free-mode'
import 'swiper/css/autoplay'

Alpine.plugin(collapse)


import { format, validate } from 'rut.js'

window.formatRut = format;
window.validateRut = validate;


window.SwiperNavigation = SwiperNavigation //remove conflict with global javascript Navigation object
window.Pagination = Pagination
window.Thumbs = Thumbs
window.FreeMode = FreeMode
window.Autoplay = Autoplay
window.Swiper = Swiper


//AlpineJS declarations
window.Alpine = Alpine
Alpine.start()

